// @ts-nocheck
import './PlaylistGroupPlylists.scss';
import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import {arrayMoveImmutable} from 'array-move';
import { playlistStore, generalStore } from '../../store';
import { RESPONSE, ROUTES, REQUESTS } from '../../js/_constants';
import Server from '../../js/config/_server';
import { apiPatch } from '../../js/api';
import { useTranslation } from 'react-i18next';
import DeleteConfirmationModal from '../deleteConfirmationModal/DeleteConfirmationModal';
import { apiDelete, apiGet } from '../../js/api';
import IconButton from '../iconButton/IconButton';

import helpers from '../../js/helpers';
import ItemCard from '../ItemCard/ItemCard';
import Loader from '../loader/Loader';
import { type Playlist } from '../../api/types/index';
import { findIndex, insert, isEmpty, propEq } from 'ramda';
import { type ActionButtonType } from '../ItemCard/ItemCard';
import SortableList, { SortableItem } from "react-easy-sort";
import ScheduleToggle from '../scheduleToggle/ScheduleToggle';

const NoPlaylistsText = () => {
    const { t } = useTranslation();
    return <p className="no-playlists">{t('playlist_group_detail_no_playlist')}</p>;
};

type PlaylistCardProps = {
    className?: string;
    playlist: Playlist;
    buttons: Array<ActionButtonType | Element | React.ReactNode>;
    rest?: React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLDivElement>,
        HTMLDivElement
    >;
};

export const PlaylistCard: React.FC<PlaylistCardProps> = ({
    className,
    playlist,
    buttons,
    ...rest
}) => {
    const { t } = useTranslation();
    return (
        <>
            <ItemCard
                className={cx('b-playlists-group__playlist-card', className)}
                key={playlist.uuid + className}
                href={`${ROUTES.PLAYLISTS}/${playlist.uuid}`}
                thumbnail={playlist.thumbnail}
                icon="media-playlist"
                title={playlist.title}
                subtitle={`${
                    playlist.language || 'EN'
                } - ${helpers.humanDuration(playlist.duration)} Min`}
                description={playlist.description}
                footer={`${t('playlist_last_edit')} : ${
                    playlist.updatedAt
                        ? helpers.humanDate(playlist.updatedAt)
                        : ''
                }`}
                buttons={buttons}
                {...rest}
            />
        </>
    );
};

type DevicePlaylistsProps = {
    items: Playlist[];
    iri: string;
};

const PlaylistGroupPlylists = ({
    items,
    iri,
}: DevicePlaylistsProps) => {
    const { t } = useTranslation();
    const { getPlaylistGroup, setPlaylistId, selectedPlaylistGroup, playlistId } = playlistStore();
    const { setModalOpen, isModalOpen } = generalStore();

    const [groupPlaylists, setGroupPlaylists] = useState<Playlist[]>(items);

    useEffect(() => {
        setGroupPlaylists(items);
    }, [items]);

    const onCancelDeletion = () => {
        setModalOpen(false);
    };

    const playlistIsAlreadyAssigned = (playlistId: string) =>
        findIndex(propEq(playlistId, '@id'), groupPlaylists) > -1;

    const [isDeleting, setIsDeleting] = useState(false);

    const [isSorting, setIsSorting] = useState(false);

    const deletePlaylist = async playlistId => {
        setIsDeleting(true);
        const newList = groupPlaylists.filter(
            item => item[RESPONSE.ID] !== playlistId
        );

        setGroupPlaylists(newList);

        const url = `${Server.baseUrl}${playlistId}`;

        await apiDelete(url).then(() => {
            setTimeout(async() => {
                await getPlaylistGroup(iri, {
                    isBackgroundRequest: true
             });

            setIsDeleting(false);
            setModalOpen(false);
            }, 1500);
        });

    };

    const onDeleteHandler = id => {
        setModalOpen(true);
        setPlaylistId(id);
    };

    const generatePlaylistActionButtons = (ele, index, itemsLength) => [
        <ScheduleToggle onChange={schedulePlaylist} playlistId={ele.itemId} presetValue={ele.schedules} />,
        {
            icon: 'remove',
            onClick: () => onDeleteHandler(ele.itemId)
        }
    ];

    const schedulePlaylist = async (schedules, playlistId) => {
        const url = `${Server.baseUrl}${playlistId}`;
            const options = {
                body: {
                    schedules: schedules.map((schedule) => ({ 
                                "type": "recurring",
                                "dayOfWeek": [1, 2, 3, 4, 5, 6, 7],
                                "startTime": schedule.split(',')[0],
                                "endTime": schedule.split(',')[1],
                            }))
                }
            };
        return  apiPatch(url, options);
    }

    const onSortEnd = async (oldIndex, newIndex) => {
        if (oldIndex !== newIndex) {
            setIsSorting(true);

            const newList = arrayMoveImmutable(groupPlaylists, oldIndex, newIndex)

            setGroupPlaylists(newList);

            const promises = newList.map((item, i) => {
                const url = `${Server.baseUrl}${item.itemId}`;
                const options = {
                    body: {
                        position: i + 1 
                    }
                };
                return apiPatch(url, options);
            });

            Promise.all(promises).then(() => {
                setIsSorting(false);
            });
        }
    };

    return (
        <>
            <div
                className={cx('b-playlists-group', {
                    'is-disabled': selectedPlaylistGroup.loading || isSorting
                })}
            >
                {(selectedPlaylistGroup.loading  || isSorting) && <Loader />}
                {isEmpty(groupPlaylists) && <NoPlaylistsText />}
                <SortableList onSortEnd={onSortEnd}>
                    {groupPlaylists.map((playlist, index) => (
                        <SortableItem key={playlistId}>
                            <div>
                                <PlaylistCard
                                    playlist={playlist}
                                    buttons={generatePlaylistActionButtons(
                                        playlist, index, groupPlaylists.length
                                    )}
                                />       
                            </div>
                        </SortableItem>)
                    )}
                </SortableList>
            </div>
            <DeleteConfirmationModal
                show={isModalOpen}
                onClose={onCancelDeletion}
                onCancel={onCancelDeletion}
                onAction={() => deletePlaylist(playlistId)}
                localeAction={t('delete')}
                localeCancel={t('cancel')}
                isLoading={isDeleting}
            >
                <h4>{t('delete_playlist_from_group')}</h4>
            </DeleteConfirmationModal>
        </>
    );
};

export default PlaylistGroupPlylists;
